(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class DivineHeaderLayout extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('header');
      this.nav = this.header.querySelector('.header__inline-menu');
      this.logo = this.header.querySelector('.header__heading-link');
      this.drawer = this.header.querySelector('header-drawer');
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      window.addEventListener('resize', this.schedule, { passive: true });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.schedule);
        this.observer.observe(this.header);
        if (this.logo) this.observer.observe(this.logo);
      }
      document.fonts?.ready.then(() => { if (this.isConnected) this.schedule(); });
      this.schedule();
    }

    update() {
      if (!this.isConnected) return;
      const desktop = window.innerWidth >= Number(this.dataset.desktopStart || 990);
      this.header.classList.remove('dd-header--compact', 'dd-header--search-compact');
      if (desktop && this.nav && this.logo && (this.header.classList.contains('header--middle-center') || this.header.classList.contains('header--middle-left'))) {
        const style = getComputedStyle(this.header);
        const innerWidth = this.header.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const gap = 2 * parseFloat(style.columnGap || 0);
        const logoWidth = this.logo.getBoundingClientRect().width;
        const links = this.nav.querySelector('.list-menu--inline');
        const icons = this.header.querySelector('.header__icons');
        const menuWidth = links?.scrollWidth || 0;
        const menuIsCentered = this.header.classList.contains('header--middle-left');
        const available = (innerWidth - (menuIsCentered ? menuWidth : logoWidth) - gap) / 2;
        const needsDrawer = () => Math.max(menuIsCentered ? logoWidth : menuWidth, icons?.scrollWidth || 0) > available + 1;
        // Keep all category links visible whenever possible. The search field
        // yields to the native search dialog before the navigation uses a drawer.
        if (needsDrawer() && this.header.classList.contains('dd-header--search-field')) {
          this.header.classList.add('dd-header--search-compact');
        }
        this.header.classList.toggle('dd-header--compact', Boolean(needsDrawer()));
      }
      if (this.drawer) {
        const breakpoint = desktop || window.innerWidth >= 990 ? 'desktop' : 'tablet';
        const drawerOpen = this.drawer.querySelector('details[open]');
        if (drawerOpen && desktop && this.nav && !this.header.classList.contains('dd-header--compact') && typeof this.drawer.closeMenuDrawer === 'function') {
          this.drawer.closeMenuDrawer(null, this.logo);
        } else if (drawerOpen && this.drawer.dataset.breakpoint !== breakpoint) {
          document.body.classList.remove(`overflow-hidden-${this.drawer.dataset.breakpoint}`);
          document.body.classList.add(`overflow-hidden-${breakpoint}`);
        }
        this.drawer.dataset.breakpoint = breakpoint;
      }
      const section = this.closest('.section-header');
      if (section) document.documentElement.style.setProperty('--header-height', `${section.offsetHeight}px`);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      window.removeEventListener('resize', this.schedule);
      this.observer?.disconnect();
    }
  }
  customElements.define('divine-header-layout', DivineHeaderLayout);

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
